"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Legal_Tab = void 0;

var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }
  return -1;
};

Legal_Tab = function () {
  function Legal_Tab() {
    var $tab_content = void 0;
    var $tab_list_items = void 0;
    var hash = void 0;
    var show_content = void 0;
    var tags = void 0;
    tags = ["#terms-of-use", "#privacy-policy", "#creator-terms"];
    hash = window.location.hash.replace("!", "");
    $tab_list_items = (0, _jquery2.default)(".tabnav li");
    $tab_content = (0, _jquery2.default)(".tab-content div");
    show_content = function show_content($this) {
      var hash_id = void 0;
      $tab_list_items.removeClass("active");
      $tab_content.removeClass("active");
      window.location.hash = $this.data("hash");
      hash_id = $this.data("hash").replace("!", "");
      return (0, _jquery2.default)(hash_id).addClass("active");
    };
    (0, _jquery2.default)("document").ready(function (e) {
      var $this = void 0;
      if (indexOf.call(tags, hash) < 0) {
        hash = "#terms-of-use";
      }
      $this = (0, _jquery2.default)(".tabnav a[href=\"" + hash + "\"]");
      show_content($this);
      return (0, _jquery2.default)($this.parent()).addClass("active");
    });
    (0, _jquery2.default)(".tabnav a").on("click", function (e) {
      var $this = void 0;
      e.preventDefault();
      $this = (0, _jquery2.default)(this);
      show_content($this);
      return (0, _jquery2.default)($this.parent()[0]).addClass("active");
    });
  }

  return Legal_Tab;
}();

exports.default = Legal_Tab;